// extracted by mini-css-extract-plugin
export default {"errorDiv":"Error_errorDiv__jLCsq","img":"Error_img__G1Eht","text":"Error_text__FJVYL"};